<template>
  <div class="activityList">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>
        <strong style="font-size: 16px;">胸卡申请</strong>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div class="operas">
     <!-- <el-button type="primary" @click="addDJCard">新增外籍参展商登记胸牌入口</el-button>-->
      <!--<el-button type="primary" @click="addCard">新增</el-button>-->
      <!--<strong> 今天是{{ today }}， 距离展会开幕还有 {{ inDays }}。 </strong>-->
    </div>
    <div style="margin: 0 0 20px; font-size: 14px;">
      <p style="width: 100%; overflow: hidden; line-height: 50px;">
        <strong style="float: left; font-size: 16px; margin-right:20px;">提供数量规则:</strong>
        <el-button type="primary" @click="addCard">新增</el-button>
        <!--<span style="float: right;">截止日期：2023/4/3</span>-->
      </p>
      <p style="line-height: 30px;">请在下表中提供贵司所有展台工作人员的信息，并在指定的截至日期前递交主办单位，入场胸卡将在现场展商服务台领取。<br/>如果您的申请超过了截止日期，将可能会延误您进场的时间。<strong>截止日期：2023/4/3</strong></p>
    </div>
    <div style="margin-bottom: 50px;">
      <table class="tablelist">
        <tr>
          <td width="60px">面积(㎡)</td>
          <td width="20px">9</td>
          <td width="20px">18</td>
          <td width="20px">24</td>
          <td width="20px">27</td>
          <td width="20px">36</td>
          <td width="20px">45</td>
          <td width="20px">54</td>
          <td width="20px">72</td>
          <td width="20px">81</td>
          <td width="20px">108</td>
          <td width="40px">108以上</td>
        </tr>
        <tr>
          <td>入场证(张)</td>
          <td>2</td>
          <td>4</td>
          <td>5</td>
          <td>6</td>
          <td>7</td>
          <td>8</td>
          <td>9</td>
          <td>12</td>
          <td>13</td>
          <td>15</td>
          <td>20</td>
        </tr>
      </table>
    </div>
    <h3 style="line-height: 50px; font-size: 16px;">胸卡列表</h3>
    <el-table
      v-if="isPC"
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{background:'#e70082',color:'#ffffff'}">
      <el-table-column
        prop="tktName"
        label="姓名">
      </el-table-column>
      <el-table-column
        prop="tktComName"
        label="公司名">
      </el-table-column>
      <!-- <el-table-column
        label="头像"
        width="160">
        <template slot-scope="scope">
          <img style="max-height:100px;" :src="scope.row.photo"/>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="tktPassportNo"
        label="身份证号">
      </el-table-column>
      <el-table-column
        prop="tktRank"
        label="职位">
      </el-table-column>
      <el-table-column
        label="操作"
        width="160">
        <template slot-scope="scope">
          <el-button @click="editCard(scope.row)" type="text" size="small" v-if="scope.row.tktZipCode!='en'">修改</el-button>
          <el-button @click="deletCard(scope.row)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <ul v-else class="cards">
      <li v-for="(val) in tableData" :key="val.id">
        <div :body-style="{ padding: '0px' }" class="cardItem">
          <div class="img"><img :src="val.photo"></div>
          <div class="rightBox">
            <p>姓名： {{val.tktName}}</p>
            <p>公司名： {{val.tktComName}}</p>
            <p>身份证号： {{val.tktIDCard}}</p>
            <p>职位： {{val.tktRank}}</p>
            <div class="bottom clearfix">
              <el-button class="button" type="primary" @click="editCard(val)">修改</el-button>
              <el-button class="button" @click="deletCard(val)">删除</el-button>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import api from '@/api'
import reg from '@/utils/regExp'
import tools from '../../utils/tools.js'
import moment from 'moment'
moment.locale('zh-cn')
export default {
  name: 'card',
  data() {
    return {
      tableData: [],
      isPC: true,
      today: moment().format('YYYY年MM月DD日'),
      inDays: ''
    }
  },
  mounted() {
    api.getexhinfo().then((res) => {
      this.inDays = moment(res.data.data.exhbtime).toNow(true)
    })
    this.isPC = tools.isPC()
    this.getTicket()
  },
  methods: {
    format(data) {
      if (data !== null){
        return moment(data).format('YYYY-MM-DD')
      } else {
        return ''
      }
    },
    addCard() {
      this.$router.push({path: '/addCard', query: {type: 'add'}})
    },
    addDJCard() {
      window.location.href="http://yzt.exporegist.com/2209jazAT/#/"
    },
    deletCard(row) {
      this.$confirm('确定删除该证件？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        api.deleteticket({tktID: ''+row.tktID}).then(res => {
          if (res.data.code === 200) {
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            });
            this.getTicket()
          }
        })
      }).catch(() => {});
    },
    resetForm() {
      this.ruleForm={
        tktName: '',
        tktComName: '',
        photo: '',
        tktIDCard: '',
        tktRank: ''
      }
    },
    getTicket() {
      api.ticketlist().then(res => {
        if (res.data.code === 200) {
          this.tableData = res.data.data
        }
      })
    },
    editCard(row, type) {
      this.$router.push({path: '/addCard', query: {type: 'edit', tktID: row.tktID}})
    }
  }
}
</script>

<style lang="less" scoped>
.activityList{
  .operas{
    text-align: right;
    padding: 20px 0;
  }
  .fileParent {
    position: relative;
    img {
      position: absolute;
      width: 60px;
      height: 39px;
      left: 0;
      top: 0;
    }
  }
  .file {
    position: absolute;
    left: 0;
    opacity: 0;
  }
  .cardItem{
      -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      display: flex;
      margin-bottom: 50px;
      padding: 20px;
      border-radius: 10px;
  }
  .cardItem .img{
      width:200px;
      height:200px;
      margin-right: 10px;
      text-align: center;
  }
  .cardItem .img img{
      max-width:100%;
      max-height:100%;
  }
  .rightBox{
    width: 65%;
    font-size:14px;
    position: relative;
    padding: 14px;
    p{
      padding-top:15px;
    }
    .bottom{
        padding-top: 20px;
    }
  }
  
  .mart30{
    padding-top:30px;
  }
  .blue{
    color:#409EFF
  }
  .tablelist{
    width: 60%;
    font-size: 16px;
    border-collapse: collapse;
  }
  .tablelist tr{
    width: 100%;
  }
  .tablelist tr td{
    text-align: center;
    border: 1px solid #444;
    height: 30px;
  }
  .cards{
    display: flex;
    flex-wrap: wrap;
    >li{
      padding: 0 20px;
      width: 50%
    }
  }
  @media screen and (max-width:540px){
    .cards>li{
      width: 100%;
      padding:0;
      .img{
        width:120px;
        height: auto;
      }
    }
    .rightBox{
      padding:0;
      font-size: 14px;
      >p{
        padding-top:10px;
      }
      .el-button{
        padding:8px 16px;
      }
    }
  }
}
</style>
